module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.aligen == 'vertical' ? '' : 'ksm-thumbnail__page--wrapper'
  }, [(_vm.aligen != 'vertical') ? _c('div', {
    staticClass: "ksm-thumbnail__page"
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 30px",
      "height": "100%"
    }
  }), _vm._v(" "), _vm._l((_vm.seiten), function(s, i) {
    return (s.variante == '') ? _c('img', {
      key: 'h' + i,
      staticClass: "ksm-thumbnail ksm-thumbnail--horizontal",
      class: i == _vm.seiteIdx ? ('active ' + _vm.modus) : _vm.modus,
      style: ('height:' + (_vm.imageHeight ? _vm.imageHeight : 125) + 'px'),
      attrs: {
        "title": s.name,
        "src": s.thumbnailSrc
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(i)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 30px",
      "height": "100%"
    }
  })], 2) : _vm._e(), _vm._v(" "), (_vm.aligen == 'vertical') ? _c('div', _vm._l((_vm.seiten), function(s, i) {
    return _c('div', {
      key: 'v' + i,
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('img', {
      staticClass: "ksm-thumbnail ksm-thumbnail--vertical",
      class: i == _vm.seiteIdx ? ('active ' + _vm.modus) : _vm.modus,
      attrs: {
        "src": s.thumbnailSrc
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(i)
        }
      }
    })])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14df7bc7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thumbnail.vue
// module id = 1955
// module chunks = 1